export class Compute {
}
export class ComputeAngle extends Compute {
    process(module) {
        const data = module.currData;
        const prevData = module.prevData;
        if (!data.primaryController || !data.secondaryController)
            return false;
        data.angle = Math.atan2(data.secondaryController.position.z - data.primaryController.position.z, data.primaryController.position.x - data.secondaryController.position.x);
        if (!prevData.angle) {
            data.startAngle = data.angle;
        }
        else {
            data.startAngle = prevData.startAngle;
        }
        return true;
    }
}
